import { GcsFile } from '@aid/shared/types/classes';
import { ContractDocumentType } from '@aid/product-contract/types/enums';

export class ContractDocument extends GcsFile {
  contract?: number;
  documentId?: number;
  submitted?: boolean;
  type?: ContractDocumentType;
}
